const tryRefresh = async () => {
  const res = await fetch(process.env.REACT_APP_API_URL + "/api/auth/refresh", {
    method: "POST",
    credentials: "include",
  });

  if (!res.ok) {
    // Auto logout if refresh fails
    window.location.href = "/ienakt";
    return false;
  }

  return true;
};

export const handleResponse = async (res) => {
  let data;

  try {
    data = await res.json();
  } catch {
    data = { error: "Invalid JSON response" };
  }

  if (res.ok) {
    return data;
  }

  throw new Error(data?.error || "Request failed");
};

export const authorizedFetch = async (url, options = {}) => {
  const headers = options.headers || {};

  const mergedOptions = {
    credentials: "include",
    ...options,
    headers: {
      ...headers,
    },
  };

  let res = await fetch(url, mergedOptions);

  if (res.status === 401 || res.status === 403) {
    const refreshed = await tryRefresh();

    if (refreshed) {
      // Retry the original request
      res = await fetch(url, mergedOptions);
    } else {
      // If refresh fails, don't throw yet — return controlled error
      return {
        _error: true,
        status: res.status,
        message: "Unauthorized after refresh",
      };
    }
  }

  try {
    const data = await res.json();
    if (!res.ok) {
      return {
        _error: true,
        status: res.status,
        message: data?.error || "Request failed",
      };
    }
    return data;
  } catch (err) {
    return { _error: true, status: res.status, message: "Invalid JSON" };
  }
};
